import { render, staticRenderFns } from "./Userinfo.vue?vue&type=template&id=2827d38f&"
import script from "./Userinfo.vue?vue&type=script&lang=js&"
export * from "./Userinfo.vue?vue&type=script&lang=js&"
import style0 from "./Userinfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports